
import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/auth/useAuth";
import { useAuthRedirect } from "@/hooks/auth/useAuthRedirect";

/**
 * Component for routes that should only be accessible when NOT authenticated
 * Like login and register pages
 */
export const PublicOnlyRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading, isInitialized } = useAuth();
  const { redirectIfAuthenticated, isReady } = useAuthRedirect();
  const hasRedirected = useRef(false);
  const initialAuthCheck = useRef(false);
  
  useEffect(() => {
    // Only check authentication status once on initialization
    if (isReady && !isLoading && isInitialized && !initialAuthCheck.current) {
      initialAuthCheck.current = true;
      
      if (isAuthenticated && !hasRedirected.current) {
        hasRedirected.current = true;
        console.log("PublicOnlyRoute: Redirecting authenticated user");
        redirectIfAuthenticated();
      }
    }
  }, [isReady, isLoading, isInitialized, isAuthenticated, redirectIfAuthenticated]);
  
  return <>{children}</>;
};
